import {PureComponent} from 'react';

export interface ArrowRightIconProps {
	color?: string;
	className?: string;
	onClick?: () => void;
	height?: number;
	width?: number;
}

export class ArrowRightIcon extends PureComponent<ArrowRightIconProps> {
	get color() {
		return this.props.color ? this.props.color : '#0077B8';
	}

	public override render() {
		const height = this.props.height || 13;
		const width = this.props.width || 8;
		return <svg className={this.props.className} width={width} height={height} viewBox={`0 0 8 13`}
		            onClick={this.props.onClick}>
			<path d='M0.196411 10.8991L4.77641 6.30908L0.196411 1.71908L1.60641 0.309082L7.60641 6.30908L1.60641 12.3091L0.196411 10.8991Z'
				fill={this.color}/>
		</svg>;
	}
}
